<template>
  <div v-if="simulationData.modals.tailings.blocks.length>0" class="modal" id="tailingsModal" tabindex="-1" aria-labelledby="tailingsModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="tailingsModalLabel">
            <i class="fa-duotone fa-trash"></i> Send to Waste
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div>
            <p>
              You will move the following block(s) to the mine waste:<br>
              <span v-for="block in modalBlocks">
              #{{ block.id}}
              </span>
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary me-auto" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary float-end" @click="tailings">
              <i class="fa-duotone fa-trash"></i> Move
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Modal} from 'bootstrap'
import Simulation from "@/views/Simulation/Simulation.vue";

export default {
  name: "TailingsModal",
  components: { Simulation },
  props: ["initData", "contents", "simulationData"],
  data() {
    return {
      Simulation
    }
  },
  computed: {
    modalBlocks() {
      return this.simulationData.modals.tailings.blocks
    },
    content() {
      return this.contents.tailingsModal
    },
  },
  methods: {
    tailings(){
      this.Simulation.methods.action(this, 27, this.modalBlocks,null)

      //CLOSE MODAL
      let modalInstance = Modal.getInstance(document.getElementById("tailingsModal"));
      modalInstance.hide();
    },
    openModal(e, blocks, map) {
      e.simulationData.modals.tailings.blocks = blocks

      setTimeout(() => {
        let modalInstance = new Modal(document.getElementById("tailingsModal"));
        modalInstance.show();
      }, 0);
    }
  },
};
</script>

<style scoped>

</style>